import React from 'react';

type Props = {
  open: boolean;
  currentUrl: string;
  linkName: string;
  onLinkNameChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
};

export const LinkDialog = ({ open, currentUrl, linkName, onLinkNameChange, onSave, onCancel }: Props) => {
  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-textPrimary bg-opacity-45 z-30" />
      <div className="bg-surface rounded-[20px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] p-[24px] absolute z-40">
        <div className="flex flex-col gap-[16px]">
          <h2 className="text-[18px] text-textPrimary noto-sans-jp-bold">
            リンク名を設定
          </h2>
          <div className="flex flex-col gap-[8px]">
            <label className="text-[12px] text-textSecondary noto-sans-jp-medium">
              URL
            </label>
            <p className="text-[14px] text-textPrimary noto-sans-jp-regular break-all">
              {currentUrl}
            </p>
          </div>
          <div className="flex flex-col gap-[8px]">
            <label className="text-[12px] text-textSecondary noto-sans-jp-medium">
              リンク名
            </label>
            <input
              type="text"
              className="border border-gray-300 rounded-[8px] p-[8px] text-[14px] noto-sans-jp-regular"
              value={linkName}
              onChange={(e) => onLinkNameChange(e.target.value)}
              placeholder="リンクの表示名を入力"
              autoFocus
            />
          </div>
          <div className="flex justify-end gap-[12px]">
            <button
              className="px-[16px] py-[8px] border border-gray-300 rounded-[8px] text-[14px] text-textSecondary noto-sans-jp-bold hover:bg-gray-100"
              onClick={onCancel}
            >
              キャンセル
            </button>
            <button
              className="px-[16px] py-[8px] bg-primary text-white rounded-[8px] text-[14px] noto-sans-jp-bold hover:bg-blue-700"
              onClick={onSave}
              disabled={!linkName.trim()}
            >
              設定
            </button>
          </div>
        </div>
      </div>
    </>
  );
}; 